import {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import defaultImg from '../../../assets/image/newShop/defaultImg.png';
import pattern from '../../../assets/image/pattern.png';
import CustomMessageArea from '../../../components/customMessageArea';
import DotsLoading from '../../../components/dotsLoading';
import ShareTitleHeader from '../../../components/mazraeKit/headers/shareTitleHeader';
import Location from '../../../components/mazraeKit/location';
import RateStarBadge from '../../../components/RateStarBadge';
import CustomersPoint from '../../../module/newShop/detailShop/customersPoint';
import useGetAdLikeStatus from '../../../services/hookService/getAdLikeStatus/useGetAdLikeStatus';
import useGetCommentsList from '../../../services/hookService/getComments/useGetCommentsList';
import useGetDetailLabCard from '../../../services/hookService/getDetailLabCard/useGetDetailLabCard';
import usePatchPostLike from '../../../services/hookService/patchPostLike/usePatchPostLike';
import {get_times_hours} from '../advertisementRegisteration/constants';
import {shopCertificate} from '../myStore/contants';
import AddCommentsBottomSheet from '../shopDetails/addCommentsBottomSheet';

const LabDetails = () => {
  const navigate = useNavigate();
  const [openAddPoints, setOpenAddPoints] = useState<boolean>(false);
  // const {inputGroupList} = useGetInputGroupList();
  const {guid} = useParams();

  const {labDetailData, isLoading} = useGetDetailLabCard(guid as string);

  const {commentsList, commentsListIsLoading, refetchAllComments} =
    useGetCommentsList(guid);

  // added a enabled = false because this api is not yet supported for labs
  const {adLikeStatusData, refetch} = useGetAdLikeStatus(
    guid || '',
    false,
    'stores',
  );
  const {editLikePost} = usePatchPostLike({
    onSuccessAction: () => {
      refetch();
    },
  });

  const handleWorkTime = () => {
    if (labDetailData?.from_hour && labDetailData?.to_hour) {
      return `${get_times_hours(labDetailData.from_hour)} الی ${get_times_hours(
        labDetailData.to_hour,
      )}`;
    } else if (labDetailData?.from_hour) {
      return `از ${get_times_hours(labDetailData.from_hour)}`;
    } else if (labDetailData?.to_hour) {
      return `تا ${get_times_hours(labDetailData.to_hour)}`;
    }
  };
  return (
    <div className="flex flex-col w-full h-full ">
      <ShareTitleHeader
        title={labDetailData?.title || ''}
        isLiked={adLikeStatusData?.like_status || false}
        onClickLike={() =>
          labDetailData?.guid &&
          editLikePost({id: labDetailData.guid, liking_type: 'stores'})
        }
      />
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <DotsLoading />
        </div>
      ) : (
        <>
          <div className="flex flex-col w-full overflow-y-auto ">
            <div className="relative w-full mb-6 h-28 ">
              <img
                src={pattern}
                className="object-cover w-full h-full"
                alt="pattern"
              />
              <div className="absolute w-20 h-20 overflow-hidden translate-x-1/2 -translate-y-1/2 rounded-full top-full right-1/2">
                <img
                  src={labDetailData?.logo || defaultImg}
                  alt="logo"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>
            <div className="flex flex-col w-full px-8 mt-8 overflow-y-auto text-gray-700">
              <div className="flex items-center justify-between w-full text-lg text-gray-900 ">
                <span className="font-medium text-md">
                  {labDetailData?.title || ''}{' '}
                </span>
                {labDetailData?.rate ? (
                  <RateStarBadge
                    rate={labDetailData?.rate}
                    propsClass="bg-gray-50"
                  />
                ) : null}
              </div>
              <div className="mt-3 mb-2">
                <Location
                  state={labDetailData?.state_info.name}
                  city={labDetailData?.city_info.name}
                  icon={<i className="icon-nameLocation" />}
                  address={labDetailData?.address}
                />
              </div>
              <p className="w-full p-0 m-0 mt-4 mb-2 font-normal text-md ">
                {labDetailData?.about}
              </p>
              <div className="border-t-[1px] border-b-[1px]">
                <div className="mt-6 !mb-4">
                  {labDetailData?.lab_field && (
                    <div className="flex justify-between">
                      <span className="text-gray-700 text-md"> آزمایش ها:</span>
                      <span className="text-md">
                        {labDetailData?.lab_field
                          ?.map(item => item.title)
                          .join(' - ')}
                      </span>
                    </div>
                  )}
                  {labDetailData?.from_hour ||
                    (labDetailData?.to_hour && (
                      <div className="flex justify-between">
                        <span>ساعات کار :</span>
                        <span>{handleWorkTime()}</span>
                      </div>
                    ))}
                  {labDetailData?.result_from_day && (
                    <div className="flex justify-between">
                      <span>زمان تقریبی ارائه نتیجه :</span>
                      <span> روز کاری{labDetailData?.result_from_day}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-between gap-4 mt-6 mb-2">
                <span className="font-medium text-md ">
                  گواهینامه‌ و اعتبارنامه‌ها:
                </span>
                <div className="flex gap-2">
                  {labDetailData?.certificate?.map((item, index) => (
                    <img
                      key={index}
                      alt="certificete"
                      className="size-[32px]"
                      src={
                        shopCertificate?.find(elem => elem.code === item)?.image
                      }
                    />
                  ))}
                </div>
              </div>

              <div className="border-b-2 border-gray-100 "></div>

              <div className="mt-8 mb-4">
                <CustomersPoint
                  {...{
                    setOpenAddPoints,
                    guid,
                    commentsList,
                    commentsListIsLoading,
                  }}
                />
              </div>
              <div
                className="flex gap-1 px-3 mt-2 text-black"
                onClick={() => navigate(`/violation-report-store/${guid}`)}
              >
                <i className="font-medium icon-namereport-2 text-xxxl text-red-1000" />
                <span className="px-2 text-[14px]">گزارش تخلف</span>
              </div>
              <div
                className="flex gap-1 px-3 my-3 text-black"
                onClick={() => navigate('/rules')}
              >
                <i className="font-medium icon-namelaw text-xxxl text-farm-shop-500" />
                <span className="px-2 text-[14px]">
                  قوانین و شرایط استفاده از فروشگاه
                </span>
              </div>
            </div>
          </div>
          <AddCommentsBottomSheet
            title={labDetailData?.title || ''}
            {...{setOpenAddPoints, openAddPoints, guid, refetchAllComments}}
          />
          <div className="flex w-full px-4 py-4 mt-auto shadow-dropShadow rounded-top-left-1 rounded-top-right-1 border-top">
            <CustomMessageArea
              phoneNumber={labDetailData?.hide_phone_number}
              labNumber={labDetailData?.phone_number}
              productId={guid}
              supplierGuid={labDetailData?.supplier_guid}
              isLab={true}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LabDetails;
